export default {
  serviceList: state => state.serviceList,
  categoryList: state => state.categoryList,
  allCategoryList: state => state.allCategoryList,
  fullCategoryServiceList: state => state.fullCategoryServiceList,
  fullCategoryServiceListWithSearch: state => name => {
    let result = [];
    if(name != '') {
        for(let i = 0; i < state.fullCategoryServiceList.length; i++) {
            let cate = JSON.parse(JSON.stringify(state.fullCategoryServiceList[i]));
            let items = [];
            for(let j = 0; j < cate.items.length; j++) {
                if(cate.items[j].name.toLowerCase().includes(name.toLowerCase())) {
                    items.push(cate.items[j]);
                }
            }
            cate.items = items;
            if(items.length > 0) {
                result.push(cate);
            }
        }
        return result;
    } else {
        // return state.fullCategoryServiceList;
        for(let i = 0; i < state.fullCategoryServiceList.length; i++) {
            let cate = JSON.parse(JSON.stringify(state.fullCategoryServiceList[i]));
            if(cate && ((cate.items && cate.items.length > 0) || cate.type == "custom" || cate.type == "gift_card")) {
                result.push(cate);
            }
        }
    }
    return result;
  },
  categoryListAll: state => state.categoryListAll,
  activeCate: state => state.categoryList,
  activeStaffData : state => state.activeStaffData,
  checkoutService : state => state.checkoutService,
  service_info: state => state.service_info,
  categoryListByType: state => state.categoryListByType,
  serviceListByType: state => state.serviceListByType,
  productListByType: state => state.productListByType,
  comboListByType: state => state.comboListByType,
  serviceListWithSearch: state => name => {
    if(name != '') {
        let search_arr = [];
        for(let i = 0; i < state.serviceList.length; i++) {
            let cate = state.serviceList[i];
            let service_temp = [];
            for(let j = 0; j < cate.services.length; j++) {
                if(cate.services[j].name.toLowerCase().includes(name.toLowerCase())) {
                    service_temp.push(cate.services[j]);
                }
            }
            search_arr.push({id: cate.id, name: cate.name, services: service_temp, color_detail: cate.color_detail});
        }
        return search_arr;
    } else {
        return state.serviceList;
    }
  },
  giftCardData: state => state.giftCardData,
  giftCardDetail: state => state.giftCardDetail,
  comboListActive: state => state.comboListActive
}
